const deeplLanguagesMapping = {
  eng: 'EN', // English - Assuming default to US or GB, DeepL supports both
  rus: 'RU', // Russian
  ita: 'IT', // Italian
  por: 'PT-PT', // Portuguese - Assuming European Portuguese, there's also 'PT-BR' for Brazilian
  tur: 'TR',
  deu: 'DE', // German
  fra: 'FR', // French
  spa: 'ES', // Spanish
  jpn: 'JA', // Japanese
  nld: 'NL', // Dutch
  cmn: 'ZH', // Mandarin Chinese
  ara: 'AR', // Arabic
  ell: 'EL', // Greek
  swe: 'SV', // Swedish
  kor: 'KO',
  cmn: 'ZH',
  vie: 'VI'
}

export const getDeeplLanguageAcronym = (threeLetterAcronym) => {
  return deeplLanguagesMapping[threeLetterAcronym]
}
